'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InfoPartition = require('../InfoPartition/InfoPartition');

var _InfoPartition2 = _interopRequireDefault(_InfoPartition);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CopyrightPolicy = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CopyrightPolicy, _Component);

  function CopyrightPolicy() {
    (0, _classCallCheck3.default)(this, CopyrightPolicy);
    return (0, _possibleConstructorReturn3.default)(this, (CopyrightPolicy.__proto__ || (0, _getPrototypeOf2.default)(CopyrightPolicy)).apply(this, arguments));
  }

  (0, _createClass3.default)(CopyrightPolicy, [{
    key: 'render',


    /* eslint-disable max-len */
    value: function render() {
      var t = this.props.t;

      var text = {
        title: t('Copyright Policy'),
        body: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            t('Cright respects the intellectual property rights of others and expects its users to do the same. In accordance with the DMCA Digital Millennium Copyright Act of 1998 and the EUCD European Union Copyright Directive of 2006 Cright will respond to claims of copyright infringement committed using the Cright service that are reported to Cright as identified in the sample notice below. Violation of trademark, copyright and other intellectual property laws may result in significant civil liability or criminal penalties under applicable law. Any reproduction or use of content, except as authorised by the owners, shall be considered to be an intentional infringement.')
          ),
          _react2.default.createElement(
            'p',
            null,
            t('If you are a copyright owner, authorized to act on behalf of one or authorized to act under any exclusive right under copyright, please report alleged copyright infringements taking place on or through the Cright services (the "Services") by completing the following Notice of Alleged Infringement and delivering it to Cright. Upon receipt of Notice as described below, Cright will take whatever action, in its sole discretion, it deems appropriate, including removal of the challenged use from the Services and/or termination of the Cright user\'s account.')
          )
        ),
        articles: [{
          key: 'notice-alleged_',
          header: t('Notice of Alleged Infringement ("Notice")'),
          bodies: [_react2.default.createElement(
            'ol',
            null,
            _react2.default.createElement(
              'li',
              null,
              t('Identify the copyrighted work that you claim has been infringed, or - if multiple copyrighted works are covered by this Notice - you may provide a representative list of the copyrighted works that you claim have been infringed.')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('Identify the material or link you claim is infringing (or the subject of infringing activity) and that access to which is to be disabled, including at a minimum, if applicable, the URL of the link shown on the relevant website where such material may be found.')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('Provide your mailing address, telephone number, and, if available, email address.')
            ),
            _react2.default.createElement(
              'li',
              null,
              t('Include both of the following statements in the body of the Notice:'),
              _react2.default.createElement(
                'p',
                { className: 'margin-left-20' },
                'i)"',
                t('I hereby state that I have a good faith belief that the disputed use of the copyrighted material is not authorized by the copyright owner, its agent, or the law (e.g., as a fair use).'),
                '"'
              ),
              _react2.default.createElement(
                'p',
                { className: 'margin-left-20' },
                'ii)"',
                t('I hereby state that the information in this Notice is accurate and, under penalty of perjury, that I am the owner, or authorized to act on behalf of the owner, of the copyright or of an exclusive right under the copyright that is allegedly infringed.'),
                '"'
              ),
              _react2.default.createElement(
                'p',
                { className: 'margin-left-20' },
                t('Provide your full legal name and your electronic or physical signature.')
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(_reactI18next.Interpolate, {
                i18nKey: 'Deliver this Notice, with all items completed, to the following contact: {{email}}',
                email: _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'mailto:legal@cright.com', rel: 'noopener noreferrer' },
                  'legal@cright.com'
                )
              })
            )
          )]
        }]
      };

      return _react2.default.createElement(_InfoPartition2.default, { text: text });
    }
    /* eslint-enable max-len */

  }]);
  return CopyrightPolicy;
}(_react.Component), _class2.propTypes = {
  t: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = CopyrightPolicy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Info/CopyrightPolicy/CopyrightPolicy.js
// module id = 2023
// module chunks = 1